modalSettingsModule = angular.module('modalWysiwyg.setting', [])

modalSettingsModule.directive "modalWysiwygSetting", ["$window", "$timeout", "$compile", "$templateCache", "$filter", ($window, $timeout, $compile, $templateCache, $filter) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->

    params =
      customConfig: "/components/ckeditor/ckeditor_config.js"
      enterMode: 2
      format_tags: "h1;h2;h3;h4;h5;h6;p;div;small",
      format_small: { element: "h6", name: "Small", attributes: {class: "small"} }
      format_div: { element: "div", name: "Обычный" }

    modalContentId = 'str-modal-content'

    editBlockInit = ->
      if !CKEDITOR.instances[modalContentId]
        CKEDITOR.disableAutoInline = true
        CKEDITOR.inline "str-modal-content", params

    angular.element(element).click ->
      vex.defaultOptions.className = 'vex-theme-os'
      vex.open
        contentClassName: "vex-button__modal"
        afterOpen: ($vexContent) ->
          $vexContent.append "<div id='#{modalContentId}' style='padding-bottom:20px' contenteditable='true'>#{scope.data}</div><button class='button button_green button_modal-save button__close-modal'>#{$filter('translate')('widget.button.action3.modalButton')}</button>"
          $(".button__close-modal").click ->
            vex.close()
          $timeout ->
            editBlockInit()
        afterClose: ($vexContent) ->
          scope.data = $vexContent.find("##{modalContentId}").html()
          scope.$apply() if !scope.$$phase
          CKEDITOR.instances[modalContentId].destroy()
          return

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/modalWysiwyg/modalWysiwyg.directive.coffee